import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
  selector: 'cxone-order-management-notes-tooltip',
  templateUrl: './cxone-order-management-notes-tooltip.component.html',
  styleUrl: './cxone-order-management-notes-tooltip.component.scss'
})
export class CxoneOrderManagementNotesTooltipComponent implements ITooltipAngularComp {
  public params!: { color: string } & ITooltipParams;

  agInit(params: { color: string } & ITooltipParams): void {
    this.params = params;
  }
}
